import { coreDefine, registerLazy } from '@/lib/component-registry';

// ── Núcleo síncrono ──────────────────────────────────────────────────────────
// Presentes em toda página; definidos imediatamente para evitar FOUC ou
// interações sem resposta antes do primeiro DOMContentLoaded.
import Header from './HeaderComponent';
import SearchButton from './SearchButton';
import Search from './Search';
import Modal from './Modal';
import ModalButton from './ModalButton';
import DynamicModalButton from './DynamicModalButton';

coreDefine('header-component', Header);
coreDefine('search-button', SearchButton);
coreDefine('search-component', Search);
coreDefine('modal-component', Modal);
coreDefine('modal-button', ModalButton);
coreDefine('dynamic-modal-button', DynamicModalButton);

// ── Lazy — registrados sob demanda via scan() ────────────────────────────────
// Cada loader é avaliado SOMENTE se o elemento existe no documento no momento
// do scan (DOMContentLoaded ou evento 'theme:components:scan').

registerLazy('age-gate',                   () => import('./AgeGate/index'));
registerLazy('carousel-slider',            () => import('./CarouselSlider/index'));
registerLazy('collection-product-grid',    () => import('./CollectionProductGrid/index'));
registerLazy('component-details',          () => import('./ComponentDetails/index'));
registerLazy('component-dropdown',         () => import('./ComponentDropdown/index'));
registerLazy('countdown-timer',            () => import('./CountdownTimer/index'));
registerLazy('customer-form',              () => import('./CustomerForm/index'));
registerLazy('discount-percentage',        () => import('./DiscountPercentage/index'));
registerLazy('facets-form',                () => import('./FacetsForm'));
registerLazy('frequently-bought-together', () => import('./FrequentlyBoughtTogether/index'));
registerLazy('installments-component',     () => import('./Installments/index'));
registerLazy('member-price',               () => import('./MemberPrice/index'));
registerLazy('newsletter-form',            () => import('./NewsletterForm/index'));
registerLazy('pix-price',                  () => import('./PixPrice/index'));
registerLazy('price-range-slider',         () => import('./PriceRangeSlider/index'));
registerLazy('product-card',               () => import('./ProductCard/index'));
registerLazy('product-media-gallery',      () => import('./ProductMediaGallery/index'));
registerLazy('quantity-input',             () => import('./QuantityInput/index'));
registerLazy('remove-button',              () => import('./RemoveButton/index'));
registerLazy('search-product-grid',        () => import('./SearchProductGrid/index'));
registerLazy('subscription-bar',           () => import('./SubscriptionBar/index'));
registerLazy('subscription-gift-button',   () => import('./SubscriptionGiftButton/index'));
registerLazy('subscription-plan-selector', () => import('./SubscriptionPlanSelector/index'));
registerLazy('subscription-price',         () => import('./SubscriptionPrice/index'));
registerLazy('winebox-quick-view',         () => import('./WineboxQuickView/index'));
registerLazy('cart-cross-sell',            () => import('./CartCrossSell/index'));
